module.exports = __webpack_public_path__ + "linkedin.png?235b1cc244eb128924f375a9a2414a69";